<template>
  <div class="ftb-pane" :id="`pane-${internalName}`" v-bind:class="{ selected: selected }" ref="tab" :data-internal-name="internalName" 
    :data-item-count="itemCount" :data-label="label" :data-hide-when-empty="hideWhenEmpty">
    <slot></slot>
  </div>
</template>

<script>
import { SessionState } from "../services/session-state.js";

export default {
  name: "Tab",
  props: {
    selected: Boolean,
    label: String,
    internalName: String,
    itemCount: Number,
    hideWhenEmpty: Boolean
  },
  data() {
    let ts = "left:" + this.left;
    return {
      tabStyle: ts,
    };
  },
  mounted() {
    if (this.$refs["tab"]) {
      var el = this.$refs["tab"].querySelector("div.tab");
      if (el) {
        var oThis = this;
        el.addEventListener("click", function (e) {
          console.log("Tab " + oThis.internalName + " selected");
          SessionState.set("app", "tab", oThis.internalName);
        });
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
span.txt > span {
  margin-left: 5px;
  display: inline-block;
  border-radius: 10px;
  background-color: #666;
  font-size: 11px;
  text-shadow: 0 0 1px rgba(0, 0, 0, 0.2);
  padding: 0 10px;
  font-weight: 700;
  color: white;
}

li.selected span.txt > span,
li:hover span.txt > span {
  background-color: #dddddd;
  color: #323232;
}

.tabbox.searchtabs:not(.flextabs) .tabs .tab .txt {
  padding: 18px;
  min-width: 130px;
}

.tabbox.h > DIV > .tabs > UL > LI > .tab > A > .txt {
  padding: 18px 10px;
}
</style>
